import { connect } from 'react-redux';
import LoadingOverlay from '../components/modals/loading-overlay';
import getSpinnerStatus from '../modules/spinner/selectors/get-spinner-status';

const mapStateToProps = (store) => ({
  spinnerData: getSpinnerStatus(store),
});

export default connect(mapStateToProps)(LoadingOverlay);
